import { useCallback, useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import { Actions as CoreActions } from '@sitecore-search/core';
import useBaseWidget from './useBaseWidget.js';
import useWidget from './useWidget.js';
export const dispatchWidgetAppearAction = (dispatch) => {
    dispatch({ type: CoreActions.WIDGET_APPEAR, payload: {} });
};
const useWidgetVisibility = () => {
    const { dispatch } = useBaseWidget();
    const { options: { visibility = {} } = {} } = useWidget();
    const { triggerOnce = true } = visibility;
    const shouldTrigger = useRef(true);
    const { ref, inView, entry } = useInView({ ...visibility, triggerOnce });
    const trigger = useCallback(() => {
        dispatchWidgetAppearAction(dispatch);
    }, [dispatch]);
    useEffect(() => {
        if (shouldTrigger.current && inView) {
            shouldTrigger.current = !triggerOnce;
            dispatchWidgetAppearAction(dispatch);
        }
    }, [dispatch, inView, entry, triggerOnce]);
    return { ref, inView, entry, trigger };
};
export default useWidgetVisibility;
